import { Box, Center, Loader } from '@mantine/core';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@workos-inc/authkit-react';
import { HeaderLayout } from '../../components/HeaderLayout';
import { Footer } from '../../components/Footer';
import { StaffSidebar } from './StaffSidebar';
import { resolveStaffRoute, staffLandingPath } from '../../staff/staffAccess';

// The /staff index target. Rendered inside StaffConsole's outlet, so claims are settled.
// eslint-disable-next-line react-refresh/only-export-components
export function StaffIndexRedirect() {
  const { permissions } = useAuth();
  return <Navigate to={staffLandingPath(permissions)} replace />;
}

// Staff shell, mirroring Profile. The gate lives here (as ProtectedRoute holds the no-org
// gate): loading → loader; non-staff → redirect to the customer hub (unadvertised); staff →
// shell. Client gate is UX only; the API's RequirePermission is the real control.
export function StaffConsole() {
  const { isLoading, permissions } = useAuth();
  const decision = resolveStaffRoute({ isLoading, permissions });

  if (decision.kind === 'loading') {
    return <Center h="100%" role="progressbar" aria-label="Loading"><Loader size="lg" /></Center>;
  }
  if (decision.kind === 'redirect') return <Navigate to={decision.to} replace />;

  return (
    <>
      <HeaderLayout />
      <Box display="flex" w="100%" flex={1} style={{ overflow: 'hidden' }} data-testid="staff-page">
        <StaffSidebar />
        <Outlet />
      </Box>
      <Footer />
    </>
  );
}
